module.exports = __webpack_public_path__ + "assets/icon-edit.31773606.svg";